import { CaretLeft } from 'phosphor-react';
import { ButtonCtaGhost } from '../button/button';
import { Header } from '../header/header';

type MobilePageDetailHeaderProps = {
  title?: string;
  onBackbuttonClick: () => void;
};

export const MobilePageDetailHeader = ({ title, onBackbuttonClick }: MobilePageDetailHeaderProps) => (
  <Header
    className="tds-mobile-detail-header px-200 md:px-400 py-100"
    title={title}
    slotLeft={<ButtonCtaGhost hideLabel icon={CaretLeft} onClick={() => onBackbuttonClick()}/>}
  />
);
